import React from 'react';
import {Stack} from '@lapilli-ui/components';
import parse from 'html-react-parser';

import {ywcasDefaultSettings} from '../../../config';
import Badge from '../badge';
import {useMediaQuery} from "../../utils/functions";

const ItemThumb = ({imageSize, marginLeft, item, showSaleBadge, showOutOfStockBadge, showFeaturedBadge, hideFeaturedIfOnSale}) => {
  const productInStock = Boolean(parseInt(item.instock));
  const hasSaleBadge = showSaleBadge && Boolean(parseInt(item.onsale));
  const hasFeatured = hideFeaturedIfOnSale && hasSaleBadge ? false : (showFeaturedBadge && Boolean(parseInt(item.featured)));
  const hasOutOfStock = showOutOfStockBadge && !productInStock;
  const {saleBadgeLabel, saleFeaturedLabel, saleOutOfStockLabel, saleBadgeColors, featuredBadgeColors, outOfStockBadgeColors} = ywcasDefaultSettings;
  const space = 25;
  const top = 5;
  const featuredTop = hasSaleBadge ? top + space : top;
  const outOfStockTop = hasFeatured ? featuredTop + space : (hasSaleBadge ? top + space : top);

  return (<Stack className="search-result-item__thumbnail" sx={{width: imageSize, marginLeft}}>
    {hasSaleBadge && <Badge className="ywcas-onsale-badge" top={top} label={parse(saleBadgeLabel)} backgroundColor={saleBadgeColors.bgcolor} color={saleBadgeColors.color}/>}
    {hasFeatured && <Badge className="ywcas-featured-badge" top={featuredTop} label={saleFeaturedLabel} backgroundColor={featuredBadgeColors.bgcolor} color={featuredBadgeColors.color}/>}
    {hasOutOfStock && <Badge className="ywcas-outofstock-badge" top={outOfStockTop} label={saleOutOfStockLabel} backgroundColor={outOfStockBadgeColors.bgcolor} color={outOfStockBadgeColors.color}/>}

    <img src={item.thumbnail} alt={item.name} width={imageSize}/>
  </Stack>);
};

export default ItemThumb;